// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"392":"3ed641e0","439":"3ed641e0"}[chunkId] + ".chunk.css";
};